"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ownerDocument = _interopRequireDefault(require("../../utils/ownerDocument"));

var _addEventListener = _interopRequireDefault(require("../../utils/addEventListener"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Resizer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Resizer, _Component);

  var _super = _createSuper(Resizer);

  function Resizer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Resizer);
    _this = _super.call(this, props);
    _this.state = {
      isDrag: false,
      startPos: {
        x: 0,
        y: 0
      }
    };
    _this.handleMove = _this.handleMove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleStart = _this.handleStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEnd = _this.handleEnd.bind((0, _assertThisInitialized2.default)(_this));

    _this.listeners = function () {
      var doc = (0, _ownerDocument.default)((0, _assertThisInitialized2.default)(_this));
      var mouseUpListener = (0, _addEventListener.default)(doc, 'mouseup', _this.handleEnd);
      var mouseMoveListener = (0, _addEventListener.default)(doc, 'mousemove', _this.handleMove);
      var touchEndListener = (0, _addEventListener.default)(doc, 'touchend', _this.handleEnd);
      var touchMoveListener = (0, _addEventListener.default)(doc, 'touchmove', _this.handleMove);
      return {
        remove: function remove() {
          mouseUpListener.remove();
          mouseMoveListener.remove();
          touchEndListener.remove();
          touchMoveListener.remove();
        }
      };
    };

    return _this;
  }

  (0, _createClass2.default)(Resizer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "isTouch",
    value: function isTouch(event) {
      return event.type === 'touchstart' || event.type === 'touchmove';
    }
  }, {
    key: "getClientX",
    value: function getClientX(event) {
      return this.isTouch(event) ? event.touches[0].clientX : event.clientX;
    }
  }, {
    key: "getClientY",
    value: function getClientY(event) {
      return this.isTouch(event) ? event.touches[0].clientY : event.clientY;
    }
  }, {
    key: "handleMove",
    value: function handleMove(event) {
      event.preventDefault();

      if (!this.state.isDrag) {
        return;
      }

      var _this$props = this.props,
          direction = _this$props.direction,
          onResize = _this$props.onResize;

      if (direction === Resizer.HORIZONTAL) {
        var diff = this.state.startPos.x - this.getClientX(event);

        if (diff !== 0) {
          onResize(diff);
        }
      }

      if (direction === Resizer.VERTICAL) {
        var _diff = this.state.startPos.y - this.getClientY(event);

        if (_diff !== 0) {
          onResize(_diff);
        }
      }

      this.updateStartPosition(event);
    }
  }, {
    key: "handleStart",
    value: function handleStart(event) {
      event.preventDefault();
      this.setState({
        isDrag: true,
        startPos: this.getStartPos(event)
      });
      this.props.onResizeStart(event);
      this.events = this.listeners();
    }
  }, {
    key: "handleEnd",
    value: function handleEnd(event) {
      this.setState({
        isDrag: false
      });
      this.props.onResizeEnd(event);
      this.removeListeners();
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (this.events) {
        this.events.remove();
      }
    }
  }, {
    key: "updateStartPosition",
    value: function updateStartPosition(event) {
      this.setState({
        startPos: this.getStartPos(event)
      });
    }
  }, {
    key: "getStartPos",
    value: function getStartPos(event) {
      return {
        x: this.getClientX(event),
        y: this.getClientY(event)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          direction = _this$props2.direction,
          position = _this$props2.position,
          children = _this$props2.children;
      var wrapperClasses = (0, _classnames.default)('Resizer', direction === Resizer.HORIZONTAL && 'resize-horizontal', direction === Resizer.VERTICAL && 'resize-vertical', position === Resizer.LEFT && 'resize-left', position === Resizer.RIGHT && 'resize-right', position === Resizer.TOP && 'resize-top', position === Resizer.BOTTOM && 'resize-bottom', className && className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClasses,
        onMouseDown: this.handleStart,
        onMouseMove: this.handleMove,
        onMouseUp: this.handleEnd,
        onTouchStart: this.handleStart,
        onTouchMove: this.handleMove,
        onTouchEnd: this.handleEnd
      }, children && children);
    }
  }]);
  return Resizer;
}(_react.Component);

Resizer.HORIZONTAL = 'x';
Resizer.VERTICAL = 'y';
Resizer.LEFT = 'left';
Resizer.RIGHT = 'right';
Resizer.TOP = 'top';
Resizer.BOTTOM = 'bottom';
Resizer.defaultProps = {
  className: '',
  direction: Resizer.HORIZONTAL,
  position: Resizer.RIGHT,
  onResizeStart: function onResizeStart() {},
  onResize: function onResize() {},
  onResizeEnd: function onResizeEnd() {}
};
Resizer.propTypes = {
  className: _propTypes.default.string,
  direction: _propTypes.default.oneOf([Resizer.HORIZONTAL, Resizer.VERTICAL]),
  position: _propTypes.default.oneOf([Resizer.LEFT, Resizer.RIGHT, Resizer.TOP, Resizer.BOTTOM]),
  onResizeStart: _propTypes.default.func,
  onResize: _propTypes.default.func.isRequired,
  onResizeEnd: _propTypes.default.func
};
var _default = Resizer;
exports.default = _default;